// extracted by mini-css-extract-plugin
module.exports = {"block":"loadBlock_block__3IE9z","fadeIn":"loadBlock_fadeIn__2_YUT"};